import { f as o } from "./function-call.js";
import { h as r } from "./has-own-property.js";
import { o as s } from "./object-is-prototype-of.js";
import { r as t } from "./regexp-flags.js";
var a = RegExp.prototype,
  p = function p(_p) {
    var e = _p.flags;
    return void 0 === e && !("flags" in a) && !r(_p, "flags") && s(a, _p) ? o(t, _p) : e;
  };
export { p as r };